import { __exports as user } from "../../../../../../_virtual/user.js";
var hasRequiredUser;
function requireUser() {
  if (hasRequiredUser) return user;
  hasRequiredUser = 1;
  Object.defineProperty(user, "__esModule", { value: true });
  user.convertUserToEvaluationContext = void 0;
  const convertUserToEvaluationContext = (user2) => {
    var _a, _b;
    if (!user2) {
      return {};
    }
    const userGroups = user2.groups;
    const userGroupProperties = user2.group_properties;
    const userGroupCohortIds = user2.group_cohort_ids;
    const context = {};
    user2 = Object.assign({}, user2);
    delete user2["groups"];
    delete user2["group_properties"];
    delete user2["group_cohort_ids"];
    if (Object.keys(user2).length > 0) {
      context["user"] = user2;
    }
    const groups = {};
    if (!userGroups) {
      return context;
    }
    for (const groupType of Object.keys(userGroups)) {
      const groupNames = userGroups[groupType];
      if (groupNames.length > 0 && groupNames[0]) {
        const groupName = groupNames[0];
        const groupNameMap = {
          group_name: groupName
        };
        const groupProperties = (_a = userGroupProperties === null || userGroupProperties === void 0 ? void 0 : userGroupProperties[groupType]) === null || _a === void 0 ? void 0 : _a[groupName];
        if (groupProperties && Object.keys(groupProperties).length > 0) {
          groupNameMap["group_properties"] = groupProperties;
        }
        const groupCohortIds = (_b = userGroupCohortIds === null || userGroupCohortIds === void 0 ? void 0 : userGroupCohortIds[groupType]) === null || _b === void 0 ? void 0 : _b[groupName];
        if (groupCohortIds && Object.keys(groupCohortIds).length > 0) {
          groupNameMap["cohort_ids"] = groupCohortIds;
        }
        groups[groupType] = groupNameMap;
      }
    }
    if (Object.keys(groups).length > 0) {
      context["groups"] = groups;
    }
    return context;
  };
  user.convertUserToEvaluationContext = convertUserToEvaluationContext;
  return user;
}
export {
  requireUser as __require
};
//# sourceMappingURL=user.js.map
